<script>
import { formatDate } from "@/utils";
export default {
  name: "SLAClolorStatus",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    const col = context.props.column;
    const val = context.props.row[col];
    const closeDate = new Date(context.props.row.ServiceRequestCloseDate);
    const DueDate = new Date(context.props.row.DueDate);
    //console.log(context.props.row);
    if (
      context.props.column == "DaysLate" ||
      context.props.column == "DiasRetrasadosSla"
    ) {
      if (
        context.props.row.DaysLate == 0 &&
        context.props.row.ClosedDate == "1753-01-01T00:00:00"
      ) {
        return createElement(
          "span",
          {
            class: "circulo-warning"
          },
          val
        );
      } else if (
        (context.props.row.DaysLate > 0 &&
          context.props.row.DaysLate != null) ||
        (context.props.row.DiasRetrasadosSla > 0 &&
          context.props.row.DiasRetrasadosSla != null)
      ) {
        return createElement(
          "span",
          {
            class: "circulo"
          },
          val
        );
      } else if (
        (context.props.row.DaysLate < 0 &&
          context.props.row.DaysLate != null) ||
        (context.props.row.DiasRetrasadosSla < 0 &&
          context.props.row.DiasRetrasadosSla != null)
      ) {
        return createElement(
          "span",
          {
            // class: "el-tag  el-tag--success el-tag--plain"
            class: "circulo-green"
          },
          0
        );
      } else {
        return createElement(
          "span",
          {
            // class: "el-tag  el-tag--success el-tag--plain"
            class: "circulo-green"
          },
          val
        );
      }
    } else {
      if (
        context.props.row.Status != 0 &&
        context.props.row.Status != 2 &&
        context.props.row.Status != 3
      ) {
        if (
          formatDate(closeDate, "DD/MM/YYYY") >
          formatDate(DueDate, "DD/MM/YYYY")
        ) {
          return createElement(
            "span",
            {
              class: "el-tag el-tag--danger el-tag--plain"
            },
            val
          );
        } else {
          return createElement(
            "span",
            {
              class: "el-tag  el-tag--success el-tag--plain"
            },
            val
          );
        }
      } else {
        return createElement(
          "span",
          {
            class: "el-tag  el-tag--default el-tag--plain"
          },
          val
        );
      }
    }
  }
};
</script>

<style>
.circulo {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: red;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 0px auto;
  padding: 3%;
}
.circulo-green {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: rgb(72, 236, 47);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 0px auto;
  padding: 3%;
}

.circulo-warning {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: yellow;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 0px auto;
  padding: 3%;
}
</style>
